import {makeAutoObservable} from "mobx";
import {
    IWalletTransaction,
    WALLET_TRANSACTION_ENUM,
    WALLET_TRANSACTION_STATUS_ENUM,
} from "../../../../services/api/wallet-service";
import {isSet} from "../../../../models/model-types-methods";

class WalletTransactionStore {
    private _model: IWalletTransaction;

    constructor(model: IWalletTransaction) {
        makeAutoObservable(this, {}, { autoBind: true });
        this._model = model;
    }

    public get id(): number { return this._model.id; }
    public get createdAt(): string { return this._model.created_at; }
    public get type(): WALLET_TRANSACTION_ENUM { return this._model.type; }
    public get typeFormatted(): string {
        if (this.type === WALLET_TRANSACTION_ENUM.TYPE_DEBT) {
            return 'Debt';
        }
        else if (this.type === WALLET_TRANSACTION_ENUM.TYPE_MANUAL_DEPOSIT) {
            return 'Manual deposit';
        }
        else if (this.type === WALLET_TRANSACTION_ENUM.TYPE_AUTO_DEPOSIT) {
            return 'Auto-recharge';
        }
        else if (this.type === WALLET_TRANSACTION_ENUM.TYPE_ADMIN_DEPOSIT) {
            return 'Admin recharge';
        }
        else if (this.type === WALLET_TRANSACTION_ENUM.TYPE_WITHDRAWAL && isSet(this.returnId)) {
            return 'Label creation';
        }
        else if (this.type === WALLET_TRANSACTION_ENUM.TYPE_WITHDRAWAL && !isSet(this.returnId)) {
            return 'Withdrawal';
        }
        else if (this.type === WALLET_TRANSACTION_ENUM.TYPE_ADMIN_WITHDRAWAL) {
            return 'Admin withdrawal';
        }
        else if (this.type === WALLET_TRANSACTION_ENUM.TYPE_PROMOTION_DEPOSIT) {
            return 'Promotion';
        }
        else if (this.type === WALLET_TRANSACTION_ENUM.TYPE_REFUND) {
            return 'Refund';
        }

        return this.type;
    }
    public get status(): WALLET_TRANSACTION_STATUS_ENUM { return this._model.status; }
    public get returnId(): number { return this._model.return_id; }
    public get currency(): string { return this._model.currency; }
    public get amount(): number { return this._model.amount; }
    public get balanceAfter(): number | null { return this._model.wallet_after_amount }
    public get reason(): string | null { return this._model.reason; }
    public get isDeposit(): boolean {
        return [
            WALLET_TRANSACTION_ENUM.TYPE_AUTO_DEPOSIT,
            WALLET_TRANSACTION_ENUM.TYPE_MANUAL_DEPOSIT,
            WALLET_TRANSACTION_ENUM.TYPE_ADMIN_DEPOSIT,
            WALLET_TRANSACTION_ENUM.TYPE_PROMOTION_DEPOSIT,
            WALLET_TRANSACTION_ENUM.TYPE_REFUND,
        ].includes(this.type);
    }
}

export default WalletTransactionStore;
